var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      staticClass: "modal-export-layer",
      attrs: {
        show: _vm.flagShow,
        title: _vm.title,
        size: "small",
        needFooter: false,
        centered: true,
      },
      on: { close: _vm.onClose },
    },
    [
      _c(
        "form",
        {
          staticClass: "export-layer-form",
          attrs: { autocomplete: "off" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "MaterialSelect",
                  {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    staticClass: "city-form-group city-bg",
                    attrs: {
                      disabled: _vm.disabled || _vm.loading,
                      id: "input-format",
                      name: "format",
                      label: "label",
                      filterable: true,
                      options: _vm.formatsList,
                      inputClasses: [
                        { "is-invalid": _vm.fnHasError("format") },
                      ],
                      error: _vm.fnFirstError("format"),
                    },
                    model: {
                      value: _vm.form.format,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "format", $$v)
                      },
                      expression: "form.format",
                    },
                  },
                  [
                    _vm._v(
                      "\n                    File Format\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }